module.exports = __webpack_public_path__ + "img/part-3-title.0419ac41.png";